import { useState } from "react";
import { Plus } from "lucide-react";
import { adminApi, formatApiError } from "../../lib/api";
import { RowActions, useCrudList } from "./AdminMagazines";
import { Field, inputCls } from "../../components/admin/fields";
import { toast } from "sonner";

export default function AdminBlog() {
  const { items, reload, remove } = useCrudList("blog");
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: "", excerpt: "", content: "", cover_image: "", published: true });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    try {
      await adminApi.post("/blog", form);
      setForm({ title: "", excerpt: "", content: "", cover_image: "", published: true });
      setShowForm(false);
      toast.success("Post published.");
      reload();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="max-w-3xl" data-testid="admin-blog-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-zinc-900">Blog / Journal</h1>
        <button onClick={() => setShowForm(!showForm)} data-testid="new-post-btn"
          className="inline-flex items-center gap-1.5 bg-zinc-900 text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-zinc-700">
          <Plus className="w-4 h-4" /> New Post
        </button>
      </div>
      {showForm && (
        <form onSubmit={save} className="bg-white border border-zinc-200 rounded-md p-6 space-y-4 mb-6" data-testid="blog-form">
          <Field label="Title *"><input required value={form.title} onChange={(e) => set("title", e.target.value)} className={inputCls} data-testid="post-title-input" /></Field>
          <Field label="Excerpt"><input value={form.excerpt} onChange={(e) => set("excerpt", e.target.value)} className={inputCls} data-testid="post-excerpt-input" /></Field>
          <Field label="Content"><textarea required rows={6} value={form.content} onChange={(e) => set("content", e.target.value)} className={inputCls} data-testid="post-content-input" /></Field>
          <button type="submit" className="bg-zinc-900 text-white text-sm font-semibold px-6 py-2.5 rounded-md" data-testid="post-save-btn">Publish</button>
        </form>
      )}
      <div className="bg-white border border-zinc-200 rounded-md divide-y divide-zinc-100" data-testid="blog-list">
        {items.map((p) => (
          <div key={p.id} className="flex items-center justify-between px-4 py-3" data-testid={`post-row-${p.slug}`}>
            <div>
              <span className="text-sm font-medium text-zinc-900">{p.title}</span>
              <p className="text-xs text-zinc-400">/blog/{p.slug} · {(p.published_at || "").slice(0, 10)}</p>
            </div>
            <RowActions onDelete={() => remove(p.id)} testId={`post-${p.slug}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
